module.exports = __webpack_public_path__ + "img/073451.f110fc71.png";